<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionSubTypeSelect
      [fixNgSelectBottom]="fractionSubTypeSelect"
      data-cy="fractionSubTypeSelect"
      class="popup-55 w-[250px]"
      [ngClass]="{
        'cursor-default': isDisabled === true
      }"
      [items]="fraction.storeFractionSubTypeOptions"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.storeFractionLogicGroupWithSubType"
      (change)="subTypeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation(); fractionSubTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); fractionSubTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{
          item.logicGroup === logicGroupEnumOr
            ? item.label || item.typeValue
            : 'NOT ' + (item.label || item.typeValue)
        }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="flex flex-row">
          <div class="ml-1 truncate">{{
            item.logicGroup === logicGroupEnumOr
              ? 'OR - ' + (item.label || item.typeValue)
              : 'AND - NOT ' + (item.label || item.typeValue)
          }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>
